exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".form-label{font-size:18px;color:#879393}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-447712d1","scoped":false,"hasInlineConfig":true}!./src/components/form-label/form-label.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-447712d1","scoped":false,"hasInlineConfig":true}!./src/components/form-label/form-label.css
// module chunks = index